import { bindActionCreators, Dispatch } from 'redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import { getDrivers } from '../../redux/modules/drivers/driversCreators';
import { connect } from 'react-redux';
import DriversPage from './DriversPage';

function mapStateToProps(state: IRootState) {
  return {
    isLoading: state.drivers.isLoading,
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    driverList: state.drivers.driverList,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    getDrivers: bindActionCreators(getDrivers, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriversPage);
